"use client"

import { useState, useEffect } from "react"
import axios from "axios"
import { motion, AnimatePresence } from "framer-motion"
import { Plus, Edit, Trash2, Save, X, Building2, ImageIcon, Eye, EyeOff, UserCheck, Trash } from "lucide-react"
import { useQuery } from "@tanstack/react-query"
import { deletePitchdeck, getAllPitchdecks, getAllStartups } from "../utils/api"
import moment from "moment"
import { toast } from "react-toastify"

const InvestorsPitchDecks = () => {
    const [investors, setInvestors] = useState([])
    const [showForm, setShowForm] = useState(false)
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedDeck, setSelectedDeck] = useState(null);

    const MIN_LIMIT = 100000;
    const MAX_LIMIT = 10000000;
    const STEP = 50000;
    const DEFAULT_RANGE = {
        minAmount: 100000,
        maxAmount: 1000000,
    };

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        number: "",
        image: "",
        linkedinProfile: "",
        investmentRange: DEFAULT_RANGE, // ✅ NEVER undefined
    });

    const [imagePreview, setImagePreview] = useState("");
    useEffect(() => {
        return () => {
            if (imagePreview) URL.revokeObjectURL(imagePreview);
        };
    }, [imagePreview]);

    const [editingId, setEditingId] = useState(null)
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
    const [deleteId, setDeleteId] = useState(null)
    const [toggle, setToggle] = useState(false)
    const [loading, setLoading] = useState(false)

    // NEW: track which investor is being processed for active toggle
    const [processingId, setProcessingId] = useState(null)

    const { data: pitchdecks, isloading, refetch } = useQuery({
        queryKey: ['pitchdecks'],
        queryFn: getAllPitchdecks
    })



    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
            investmentRange: prev.investmentRange ?? DEFAULT_RANGE, // 🛡️ GUARANTEE
        }));
    };

    const convertToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        })

    //   const handleFormSubmit = async (e) => {
    //     e.preventDefault()
    //     setLoading(true)
    //     try {
    //       if (editingId) {
    //         await axios.put(`${process.env.REACT_APP_API_URL}/api/ourinvestors/${editingId}`, formData)
    //       } else {
    //         await axios.post(`${process.env.REACT_APP_API_URL}/api/ourinvestors`, formData)
    //       }
    //       setFormData({
    //         ...formData, name: "",
    //         email: "",
    //         number: "",
    //         image: "",
    //         linkedinProfile: "",
    //         investmentRange: DEFAULT_RANGE
    //       })
    //       setShowForm(false)
    //       setEditingId(null)
    //       fetchInvestors()

    //     } catch (error) {
    //       console.error("Error submitting form:", error)
    //     } finally {
    //       setLoading(false)
    //     }
    //   }






    // const { data: startups, isLoading, refetch } = useQuery({
    //   queryKey: ['startups'],
    //   queryFn: getAllStartups
    // })

    // useEffect(() => {
    //   console.log(startups)
    // }, [startups])

    const dummyPitchDecks = [
        {
            _id: "1",
            startupName: "FinPay",
            investorName: "Ramesh Kumar",
            description: "Digital payment solution for small businesses",
            status: "submitted",
            createdAt: "2026-01-10",
        },
        {
            _id: "2",
            startupName: "HealthX",
            investorName: "Anita Sharma",
            description: "AI-powered health monitoring platform",
            status: "viewed",
            createdAt: "2026-01-09",
        },
        {
            _id: "3",
            startupName: "EduSpark",
            investorName: "Vikram Menon",
            description: "Personalized learning platform for students",
            status: "shortlisted",
            createdAt: "2026-01-08",
        },
    ];
    const getPitchStatusColor = (status) => {
        switch (status) {
            case "submitted":
                return "bg-blue-50 text-blue-700 border-blue-200";
            case "viewed":
                return "bg-purple-50 text-purple-700 border-purple-200";
            case "shortlisted":
                return "bg-green-50 text-green-700 border-green-200";
            case "rejected":
                return "bg-red-50 text-red-700 border-red-200";
            default:
                return "bg-gray-50 text-gray-700 border-gray-200";
        }
    };

    const downloadPitchDeck = (base64Data, fileName = "pitch-deck.pdf") => {
        const link = document.createElement("a");
        link.href = base64Data;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const onDeletePitchdeck=async(id)=>{
        try {
            const responce=await deletePitchdeck(id)
            toast.success(responce.message)
            refetch()
        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        console.log(pitchdecks)
    }, [pitchdecks])


    return (
        <>
            <div className="min-h-screen bg-gray-50">
                <div className="w-full mx-auto p-6">

                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
                        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center">
                                    <Building2 className="w-6 h-6 text-white" />
                                </div>
                                <div>
                                    <h1 className="text-3xl font-bold text-gray-900">  Pitch Deck Submissions</h1>
                                    <p className="text-gray-500"> View all startup pitch decks submitted to investors</p>
                                </div>
                            </div>


                        </div>
                    </div>


                    {/* Cards Grid */}
                    {isloading ? (
                        /* 1️⃣ Loading State */
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6">
                            {Array.from({ length: 4 }).map((_, index) => (
                                <PitchDeckSkeleton key={index} />
                            ))}
                        </div>
                    ) : pitchdecks?.pitchDecks?.length === 0 ? (
                        /* 2️⃣ Empty State */
                        <div className="flex flex-col items-center justify-center py-20 text-center">
                            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
                                📄
                            </div>
                            <h3 className="text-lg font-semibold text-gray-700 mb-2">
                                No Pitch Decks Found
                            </h3>
                            <p className="text-sm text-gray-500">
                                No startups have submitted pitch decks yet.
                            </p>
                        </div>
                    ) : (
                        /* 3️⃣ Data State */
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6">
                            <AnimatePresence>
                                {pitchdecks?.pitchDecks?.map((deck, index) => (
                                    <motion.div
                                        key={deck._id}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -20 }}
                                        transition={{ delay: index * 0.05 }}
                                        className="
            bg-white rounded-xl border border-gray-200
            shadow-sm hover:shadow-md
            transition-all duration-300
            p-5 sm:p-6 lg:p-7
            flex flex-col
          "
                                    >
                                        {/* Header */}
                                        <div className="mb-3">
                                            <h3 className="text-base sm:text-lg font-semibold text-gray-900 truncate">
                                                {deck.startupName}
                                            </h3>
                                            <p className="text-xs sm:text-sm text-gray-500">
                                                Pitched to Investor{" "}
                                                <span className="font-medium">
                                                    {deck?.investorId?.name}
                                                </span>
                                            </p>
                                        </div>

                                        {/* Description */}
                                        <p className="text-sm text-gray-600 mb-4 line-clamp-3">
                                            {deck.description}
                                        </p>

                                        {/* Footer */}
                                        <div className="mt-auto">

                                            <div className="flex justify-between items-center">
                                                <span className="text-xs text-gray-400">
                                                    {moment(deck.createdAt).fromNow()}
                                                </span>

                                                <button
                                                onClick={()=>onDeletePitchdeck(deck._id)}
                                                    className="inline-flex items-center justify-centerw-8 h-8 rounded-lg text-red-600 bg-red-50 hover:bg-red-100 hover:text-red-700 transition-colors "
                                                    title="Delete pitch deck"
                                                >
                                                    <Trash className="w-4 h-4" />
                                                </button>
                                            </div>

                                            <div className="flex flex-col sm:flex-row gap-2">       
                                                <button
                                                    onClick={() => {
                                                        setSelectedDeck(deck);
                                                        setShowViewModal(true);
                                                    }}
                                                    className="w-full px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition"
                                                >
                                                    View Deck
                                                </button>

                                                <button
                                                    onClick={() =>
                                                        downloadPitchDeck(
                                                            deck.pitchDeckUrl,
                                                            `${deck.startupName}-PitchDeck.pdf`
                                                        )
                                                    }
                                                    className="w-full px-4 py-2 text-sm font-medium text-green-600 bg-green-50 rounded-lg hover:bg-green-100 transition"
                                                >
                                                    Download Deck
                                                </button>
                                            </div>
                                        </div>
                                    </motion.div>
                                ))}
                            </AnimatePresence>
                        </div>
                    )}

                </div>
            </div>

            <AnimatePresence>
                {showViewModal && selectedDeck && (
                    <motion.div
                        className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center px-4"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <motion.div
                            className="bg-white w-full max-w-4xl rounded-xl shadow-lg overflow-hidden"
                            initial={{ scale: 0.95, y: 30, opacity: 0 }}
                            animate={{ scale: 1, y: 0, opacity: 1 }}
                            exit={{ scale: 0.95, y: 30, opacity: 0 }}
                            transition={{ duration: 0.25 }}
                        >
                            {/* Header */}
                            <div className="flex items-center justify-between px-6 py-4 border-b">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900">
                                        {selectedDeck.startupName}
                                    </h3>
                                    <p className="text-sm text-gray-500">
                                        Pitched to{" "}
                                        <span className="font-medium">
                                            {selectedDeck?.investorId?.name}
                                        </span>
                                    </p>
                                </div>

                                <button
                                    onClick={() => setShowViewModal(false)}
                                    className="text-gray-400 hover:text-gray-600 text-xl"
                                >
                                    ✕
                                </button>
                            </div>

                            {/* Body */}
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-6">
                                {/* Details */}
                                <div>
                                    <h4 className="text-sm font-semibold text-gray-700 mb-2">
                                        Description
                                    </h4>
                                    <p className="text-sm text-gray-600 mb-4">
                                        {selectedDeck.description}
                                    </p>

                                    <p className="text-xs text-gray-400">
                                        Submitted {moment(selectedDeck.createdAt).fromNow()}
                                    </p>

                                    <button
                                        onClick={() =>
                                            downloadPitchDeck(
                                                selectedDeck.pitchDeckUrl,
                                                `${selectedDeck.startupName}-PitchDeck.pdf`
                                            )
                                        }
                                        className="mt-4 inline-flex items-center px-4 py-2 text-sm font-medium text-green-600 bg-green-50 rounded-lg hover:bg-green-100 transition"
                                    >
                                        Download PDF
                                    </button>
                                </div>

                                {/* PDF Preview */}
                                <div className="border rounded-lg overflow-hidden h-[60vh]">
                                    <iframe
                                        src={selectedDeck.pitchDeckUrl}
                                        title="Pitch Deck Preview"
                                        className="w-full h-full"
                                    />
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>


        </>

    )
}

export default InvestorsPitchDecks;


const PitchDeckSkeleton = () => {
    return (
        <div
            className="
        bg-white rounded-xl border border-gray-200
        shadow-sm p-5 sm:p-6 lg:p-7
        animate-pulse flex flex-col
      "
        >
            {/* Header */}
            <div className="mb-4">
                <div className="h-5 w-2/3 bg-gray-200 rounded mb-2"></div>
                <div className="h-4 w-1/2 bg-gray-200 rounded"></div>
            </div>

            {/* Description */}
            <div className="space-y-2 mb-4">
                <div className="h-4 bg-gray-200 rounded"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6"></div>
                <div className="h-4 bg-gray-200 rounded w-4/6"></div>
            </div>

            {/* Footer */}
            <div className="mt-auto">
                <div className="h-3 w-1/3 bg-gray-200 rounded mb-4"></div>

                <div className="flex flex-col sm:flex-row gap-2">
                    <div className="h-9 w-full bg-gray-200 rounded-lg"></div>
                    <div className="h-9 w-full bg-gray-200 rounded-lg"></div>
                </div>
            </div>
        </div>
    );
};
